import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from '../CTAButton';
import { LegalLinks, LegalModals, useLegalModals } from '../LegalModals';
import { buildCheckoutUrl, CART_URLS, openCheckout } from '../../utils/checkoutUrls';
export function UrgencySection() {
  const {
    activeModal,
    setActiveModal
  } = useLegalModals();
  return <section className="bg-gradient-to-b from-[#3A4A4A]/80 to-[#4A5A4A]/80 backdrop-blur-[2px] text-white py-24 relative overflow-hidden" data-id="element-370">
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
      backgroundSize: '32px 32px'
    }} data-id="element-371"></div>

      <div className="container mx-auto px-6 max-w-3xl text-center relative z-10" data-id="element-372">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-373">
          <div className="mb-12" data-id="element-374">
            <CTAButton text="Completar mi compra" variant="primary" className="w-full sm:w-auto min-w-[300px] shadow-xl" onClick={() => window.open(buildCheckoutUrl(), '_blank')} data-id="element-375" />
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 mb-12 border border-white/20" data-id="element-376">
            <p className="text-lg font-medium" data-id="element-377">
              Esta oferta especial solo está disponible en esta página. Una vez
              que salgas, estos bonos volverán a su precio normal.
            </p>
          </div>

          <h2 className="text-3xl md:text-4xl font-heading font-semibold mb-6 leading-tight" data-id="element-378">
            Aprovecha esta oferta especial
          </h2>

          <p className="text-xl text-white/90 mb-12" data-id="element-379">
            Obtén estos recursos adicionales por un precio exclusivo disponible
            solo en esta página.
          </p>

          <div className="flex flex-col items-center space-y-6" data-id="element-380">
            <CTAButton text="Sí, quiero todos los bonos" variant="light" className="w-full sm:w-auto min-w-[300px]" onClick={() => window.open(CART_URLS.allBonuses, '_blank')} data-id="element-381" />

            <button onClick={openCheckout} className="text-white/60 hover:text-white transition-colors underline underline-offset-4 text-sm mt-4" data-id="element-382">
              No gracias, continuar sin los bonos
            </button>
          </div>

          <div className="w-full h-[1px] bg-white/20 mt-16 mb-8" data-id="element-383"></div>

          <p className="text-white/60 text-sm" data-id="element-384">
            © {new Date().getFullYear()} — Todos los derechos reservados
          </p>

          <LegalLinks className="mt-4" onPrivacy={() => setActiveModal('privacy')} onTerms={() => setActiveModal('terms')} data-id="element-385" />
        </motion.div>
      </div>

      <LegalModals activeModal={activeModal} onClose={() => setActiveModal(null)} data-id="element-386" />
    </section>;
}